// Arms [data-reveal] elements and marks them .is-inview once they scroll into view,
// so their CSS entrance (e.g. handwritten notes) plays once. Without this script, or
// with reduced motion, the content is simply visible.
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

function arm(root = document) {
  if (reduced.matches || typeof window.IntersectionObserver !== 'function') return;
  const targets = [...root.querySelectorAll('[data-reveal]:not(.is-armed)')];
  if (!targets.length) return;
  const observer = new window.IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('is-inview');
      observer.unobserve(entry.target);
    }
  }, { threshold: 0.4 });
  for (const target of targets) {
    target.classList.add('is-armed');
    observer.observe(target);
  }
}

arm();
document.addEventListener('shopify:section:load', event => arm(event.target));
